
import My from './list'
import QrCard from './qrCard'

export {QrCard}
export default My